export default __webpack_public_path__ + "static/media/a026-example8.aad4ee0f.png";